import ScansGroupedReport from "./ScansGroupedReport";

export default function ScanByState() {
  return (
    <ScansGroupedReport
      title="Scan by State"
      subtitle="Scans grouped by the state of the scanned QR / fuel access's retail outlet."
      dimension="state"
      dropdownLabel="State"
      dropdownPlaceholder="All states"
      dropdownApiPath="/master/states"
    />
  );
}
